import React from 'react';
import { Grid, FormControl, FormControlLabel, RadioGroup, Radio } from '@mui/material';
import Validation from 'components/form/validation/validation';

interface RenderFinancialResponsibilityProps {
  input: {
    value: string;
    onChange: (value: string) => void;
  };
  onChange?: (value: string) => void;
  meta: {
    touched: boolean;
    error?: string;
    warning?: string;
  };
}

export default function RenderFinancialResponsibility({
  input,
  onChange,
  meta: { touched, error, warning },
}: RenderFinancialResponsibilityProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (onChange) {
      onChange(value);
    }
    if (input.onChange) {
      input.onChange(value);
    }
  };

  return (
    <Grid container>
      <FormControl component="fieldset" style={{ width: '100%' }}>
        <RadioGroup
          row
          name="financial-responsibility"
          value={input.value || 'yes'}
          onChange={handleChange}
        >
          <FormControlLabel
            value="yes"
            control={
              <Radio
                color="primary"
                inputProps={
                  {
                    'data-qa-id': 'financial-responsibility-yes',
                  } as any
                }
              />
            }
            label="Yes - payment method obtained or no financial responsibility"
          />
          <FormControlLabel
            value="deferred"
            control={
              <Radio
                color="primary"
                inputProps={
                  {
                    'data-qa-id': 'financial-responsibility-deferred',
                  } as any
                }
              />
            }
            label="Deferred/pending"
          />
        </RadioGroup>
      </FormControl>
      <Validation touched={touched} error={error} warning={warning} />
    </Grid>
  );
}
